import api from "./api";

const QUEUE = [];
let sid = null;
try {
  sid = sessionStorage.getItem("pm_sid");
  if (!sid) { sid = Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem("pm_sid", sid); }
} catch { sid = "anon"; }

function dnt() {
  return navigator.doNotTrack === "1" || window.doNotTrack === "1" || navigator.msDoNotTrack === "1";
}

function flush() {
  if (!QUEUE.length) return;
  const events = QUEUE.splice(0, QUEUE.length);
  api.post("/analytics/event", { events, dnt: dnt() }).catch(() => {});
}

setInterval(flush, 5000);
if (typeof window !== "undefined") {
  window.addEventListener("beforeunload", flush);
  window.addEventListener("visibilitychange", () => { if (document.visibilityState === "hidden") flush(); });
}

function utm() {
  try {
    const p = new URLSearchParams(window.location.search);
    return { source: p.get("utm_source"), medium: p.get("utm_medium"), campaign: p.get("utm_campaign") };
  } catch { return {}; }
}

export function track(event, props = {}) {
  try {
    QUEUE.push({
      event, path: window.location.pathname, ref: document.referrer || "",
      utm: utm(), sid, lang: localStorage.getItem("pm_lang") || "en",
      ref_code: (utm().campaign || null), props,
    });
    if (QUEUE.length >= 8) flush();
  } catch {}
}

export function trackPage() { track("page_view"); }
